import React from 'react';
import _get from "lodash/get";
/*ui*/
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
/*component*/
import listingCardGeneralStyles from "../../../theme/listingCardGeneralStyles";
import toLocale from "../../../helpers/toLocale";

const useStyles = makeStyles((theme) => ({
    ...listingCardGeneralStyles(theme),
}))

const DetailsCarPriceBlue = (carData) => {
    const classes = useStyles();

    if (!carData.total_car_price) return;

    const showDiscountPrice = +_get(carData,'final_discount_percentage',0) > 0 ;

    if (!showDiscountPrice) {
        return <div className={classes.noOldPrice}>{toLocale(carData.total_car_price)}€ <span className={classes.tva}>TVA <br />inclus</span></div>
    } else {
        return (
            <React.Fragment>
                <div>
                    <div>
                        {toLocale(carData.client_invoice_price)}€ <span className={classes.tva}>TVA <br />inclus</span>
                    </div>
                    <Typography align={"left"} component={"div"} variant="caption" className={`${classes.colorBlueGrey} ${classes.oldPrice}`}>
                        <span className={classes.lineThrough}>
                            {toLocale(carData.total_car_price)}€
                        </span>
                        <span className={classes.oldPriceDiscount}>
                            <span className={classes.tva}>TVA <br />inclus</span>
                        </span>
                    </Typography>
                </div>
            </React.Fragment>
        )
    }
}

export default DetailsCarPriceBlue;
